// extracted by mini-css-extract-plugin
module.exports = {"root":"tooltip_root__1E9Sy"};